// Constants
import { ClientFlavor, Environment } from "@ms/uno-constants/lib/local/AppConstants";
import { NewMyTasksExperienceLocalStorageKey } from "@ms/uno-constants/lib/local/PersistenceConstants";
import { SubRouteKeys, SubRouteType, ViewType } from "@ms/uno-constants/lib/local/RoutingConstants";
import { DefaultMyPlansPagePivotType, DefaultMyTasksViewPivotType } from "@ms/uno-constants/lib/local/ViewPivots";
/**
 * Provides the initial route based on the app flavor and configuration
 */
export function getInitialRoute(clientFlavor, environment) {
    return {
        rootUrl: "", // TODO [ADO#8706197] - Should be the teams root url (but setting this currently breaks RouteStore - Need to investigate/fix)
        subRouteType: getInitialSubRouteType(clientFlavor, environment),
        subRoute: getInitialSubRoute(clientFlavor, environment),
        queryParameters: {},
    };
}
/**
 * Provide the initial subRouteType based on the app flavor
 */
export function getInitialSubRouteType(clientFlavor, environment) {
    switch (clientFlavor) {
        case ClientFlavor.ConfigTab:
            return SubRouteType.ConfigTeamsTab;
        case ClientFlavor.RemoveTab:
            return SubRouteType.RemoveTeamsTab;
        case ClientFlavor.TaskFromMessage:
            return SubRouteType.MessageTasks;
        default:
            // If running in Bleu environment, default to MyPlans. Otherwise, MyTasks.
            if (environment === Environment.Bleu) {
                return SubRouteType.MyPlans;
            }
            return SubRouteType.MyTasks;
    }
}
/**
 * Provide the initial subRoute based on the app flavor and configuration
 */
export function getInitialSubRoute(clientFlavor, environment) {
    if (clientFlavor === ClientFlavor.TaskFromMessage) {
        return [];
    }
    else {
        const subRouteType = getInitialSubRouteType(clientFlavor, environment);
        if (subRouteType === SubRouteType.MyPlans) {
            return [DefaultMyPlansPagePivotType];
        }
        const viewType = subRouteType === SubRouteType.MyTasks ? migrateMyTasksViewPreference() : ViewType.Grid;
        return [DefaultMyTasksViewPivotType, SubRouteKeys.View, viewType];
    }
}
/**
 * One-time migration: if the user previously opted into the new MyTasks experience
 * via the localStorage toggle, return ViewType.List so the initial route reflects
 * their preference. The key is NOT removed here because flights aren't available at
 * bootstrap — if the flight is rolled back, the List fallback in renderView() degrades
 * to the default view gracefully, and the key stays for a future re-enable.
 * The key is cleaned up in MyTasksPage once the flight is confirmed active.
 */
function migrateMyTasksViewPreference() {
    try {
        if (localStorage.getItem(NewMyTasksExperienceLocalStorageKey) === "true") {
            return ViewType.List;
        }
    }
    catch {
        // localStorage may be unavailable
    }
    return ViewType.Grid;
}
/**
 * Returns true when every segment of `prefix` matches the corresponding segment of `full`.
 * Used to detect spurious Teams cached-load events where the incoming route is a shallower
 * version of the current in-app route (e.g. tab base URL vs open task detail URL).
 * @param prefix The incoming sub-route from the cached-load event
 * @param full The current sub-route from the route store
 */
export function isSubRoutePrefixOf(prefix, full) {
    if (prefix.length > full.length) {
        return false;
    }
    for (let i = 0; i < prefix.length; i++) {
        if (prefix[i] !== full[i]) {
            return false;
        }
    }
    return true;
}
